<template>
  <div class="d-flex flex-column">
    <div class="text-caption">{{ title }}</div>
    <div class="text-body-2 black--text">{{ value }}</div>
  </div>
</template>
<script>
export default {
  props: { title: String, value: String },
}
</script>
